var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stat"},[_c('div',{staticClass:"stat-icon"},[_c('i',{class:_vm.icon,style:(_vm.style)})]),_c('div',{staticClass:"stat-info"},[_c('span',{staticClass:"stat-title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"stat-value"},[_vm._v(_vm._s(_vm.value))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }